import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SecuritiesTransfersRestService } from './securities-transfers-rest.service';
import { SecuritiesTransfersAccounts } from './securities-transfers.domain';

@Injectable()
export class SecuritiesTransfersResolveService {
  private readonly securitiesTransfersRestService = inject(SecuritiesTransfersRestService);

  getSecuritiesTransfersAccounts(accountId: string): Observable<SecuritiesTransfersAccounts> {
    return this.securitiesTransfersRestService.getSecuritiesTransfersAccounts(accountId);
  }
}
